<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "contract"
    }
</script>

<style scoped>

</style>